<template>
<v-card flat >
  <!-- <v-card-title class='subheading' >
    {{ $t('title') }}
    <v-spacer></v-spacer>
  </v-card-title> -->
  <v-tabs v-model='activeTab' >
    <v-tab >{{ $t('tabs.history') }}</v-tab>
    <v-tab >{{ $t('tabs.usage') }}</v-tab>
    <v-spacer></v-spacer>
    <help-popover v-if='activeTab==0' class='mr-4 mt-2' >
      {{ $t('help.history') }}
    </help-popover>
    <help-popover color='success' v-if='activeTab==1' class='mr-4 mt-2' >
      {{ $t('help.usage') }}
    </help-popover>
    <v-tabs-items v-model='activeTab' >
      <v-tab-item >
        <treatment-logs
          :relationship-id='relationshipId' >
        </treatment-logs>
      </v-tab-item>
      <v-tab-item >
        <historical-usage
          :client-id='clientId'
          :relationship-id='relationshipId' >
        </historical-usage>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</v-card>
</template>

<script>
import HelpPopover from '@/components/ui/HelpPopover'
import TreatmentLogs from './codes/TreatmentLogs'
import HistoricalUsage from './codes/HistoricalUsage'

export default {
  name: 'ClientCodes',
  components: {HelpPopover, HistoricalUsage, TreatmentLogs},
  props: {
    relationshipId: { type: Number, required: true },
    clientId: { type: Number, required: true },
    // recordId: { type: Number, required: true },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      activeTab: 0,
      'searchString': '',
      'orderByLastUsed': true,
      'codes': [],
      'codeCount': 4,
      'loading': false,
      'requests': {
        record: 'record-get-request',
        get: 'get-treatment-logs',
        change: 'change-treatment-logs'
      },
      touchers: {
        editform: 1
      },
      dialogs: {
        add: false
      }
    }
  },
  computed: {
    orderByText () {
      if (this.orderByLastUsed) {
        return this.$t('lastused')
      }
      return this.$t('firstused')
    },
    orderByValue () {
      if (this.orderByLastUsed) {
        return 'last_used'
      }
      return 'first_used'
    },
    mostRecentAppointmentDate () {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        let dt = this.sortedHistoricalTreatmentLogs[0].last_used
        return this.luxonDateformat(dt, 'ccc d MMM yyyy')
      }
    },
    oldestAppointmentDate () {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        let codes = this.sortedHistoricalTreatmentLogs
        let dt = codes[codes.length - 1].last_used
        return this.luxonDateformat(dt, 'ccc d MMM yyyy')
      }
    },
    recordRequest () {
      return this.$store.getters.getRequestById(this.requests.record, true)
    },
    treatmentLogsRequest () {
      return this.$store.getters.getRequestById(this.requests.get, true)
    },
    changeLogsRequest () {
      return this.$store.getters.getRequestById(this.requests.change, true)
    },
    changeLogsRequestStatus () {
      return this.changeLogsRequest.status
    },
    record () {
      return this.getObjectPath(this.recordRequest, 'result.data', {})
    },
    historicalTreatmentLogs () {
      return this.getObjectPath(this.treatmentLogsRequest, 'result.data', [])
    },
    sortedHistoricalTreatmentLogs () {
      if (!this.historicalTreatmentLogs) { return [] }
      let order = this.orderByValue || 'last_used'
      return this.historicalTreatmentLogs.sort((a, b) => {
        if (a[order] === b[order]) { return 0 }
        if (a[order] > b[order]) { return -1 }
        return 1
      })
    },
    filteredHistoricalTreatmentLogs () {
      let sorted = this.sortedHistoricalTreatmentLogs
      if (this.searchString && this.searchString.length > 0) {
        return sorted.filter((log) => {
          if (log.code) {
            return (log.code.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1)
          }
        })
      }
      return sorted
    },
    currentTreatmentLogs () {
      return this.record.treatmentlogs || []
    }
  },
  watch: {
    touch: {
      immediate: true,
      handler () {
        this.getCodes()
      }
    }
  },
  methods: {
    getRecord () {
      let params = {
        practitioner_id: this.me.id,
        customer_id: this.clientId
      }
      this.$medicalaidguru
        .resource('record')
        .id(this.requests.record)
        .get(this.clientId, params)
    },
    getCodes () {
      let suffix = this.clientId + '/codes'
      this.$appointmentguru
        .resource('practitioner.clients')
        .id(this.requests.get)
        .get(suffix)
    },
    save (log) {
      log.record = this.record.id
      this.$medicalaidguru
        .resource('treatmentlog')
        .id(this.requests.change)
        .create(JSON.stringify(log))
    },
    dodelete (log) {
      this.$medicalaidguru
        .resource('treatmentlog')
        .id(this.requests.change)
        .delete(log.id)
    },
    isNewDate (log, index, logs) {
      if (index === 0) { return true }
      let last = logs[index - 1]
      return (log[this.orderByValue] !== last[this.orderByValue])
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Diagnosis and treatment history',
        nologsfound: 'No treatment logs found',
        timesUsed: 'Never used | Used once | Used {count} times',
        zerocurrentresults: 'No history recorded yet',
        zerosearchresults: 'Your search returned no results',
        lastused: 'last used',
        firstused: 'first used',
        buttons: {
          add: 'Add',
          addwithdescription: 'Add an item'
        },
        tabs: {
          history: 'Client History',
          usage: 'Code usage'
        },
        logs: {
          historical: 'Codes previously used',
          historicalsubtitle: '(sorted by last time used)',
          count: 'Never used|Used once|Used twice|Used {n} times',
          summary: '{n} codes used | {n} code used since {from} | {n} codes used since {from}',
          searchinfo: 'Searching for {string}',
          lastseen: 'Last seen: {date}'
        },
        help: {
          history: 'Treatment logs help you keep track of diagnosis and treatments for a patient over time. You can also use them to speed up your invoicing by automatically adding current treatment codes to new appointments for this patient',
          usage: 'Code usage shows the codes as you have actually used them on appointments over time'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientCodes.vue?0f43abbc